

























































































































































/** @format */

import { Vue, Component, Mixins, Watch, Prop } from 'vue-property-decorator';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import moment from 'moment';
import { phone } from '@root/utils/validators';
import { carPlateReg, carPlateValidate } from '@root/utils/validator-util';
import { addAppointmentRecord } from '@/api/visitor-car-management';
import Utils from '@root/utils/common';
import ModalConfig from '@/components/modal-config/index.vue';
@Component({
  components: {
    ParkingLotSearch,
    ModalConfig
  }
})
export default class NewBooking extends Vue {
  // 来访缘由
  //cp_appointment_visitor_type

  get visitorTypeOptions() {
    return Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries['cp_appointment_visitor_type']) || [];
  }

  @Prop({ default: false })
  private value?: boolean;

  formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 5 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 }
    }
  };

  rangeConfig = {
    rules: [{ type: 'array', required: true, message: '请选择来访时间' }]
  };
  form?: any;
  validatorsPhone = phone;
  confirmLoading = false;
  plate: any = '';
  beforeCreate() {
    const arr = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries['cp_appointment_visitor_type']) || [];
    console.log('arr[0]', arr[0]);
    this.form = this.$form.createForm(this, {
      mapPropsToFields: () => {
        return {
          visitorType: this.$form.createFormField({
            value: arr[0] ? arr[0].value || '' : ''
          })
        };
      }
    });
  }
  plateValidation = carPlateValidate;
  // plateValidation(rule: any, value: any, callback: any) {
  //   const form = this.form
  //   if (value) {
  //     let plateList: [] = value.replace(/，/g, ',').split(',') || []
  //     let errArr: number[] = []
  //     plateList.forEach((item: any, index: number) => {
  //       if (item && !carPlateReg.test(item)) {
  //         errArr.push(index + 1)
  //       }
  //     })
  //     if (errArr && errArr.length > 0) {
  //       callback(`输入的第${errArr.join(',')}个车牌有误`)
  //     } else {
  //       callback()
  //     }
  //   } else {
  //     callback()
  //   }
  // }

  get visibleShow() {
    return this.value;
  }
  set visibleShow(val) {
    this.$emit('input', false);
  }
  handleOk() {
    this.form.validateFieldsAndScroll(async (err: any, values: any) => {
      if (!err) {
        this.confirmLoading = true;
        let {
          parkId = '',
          plateNos = '',
          visitor = '',
          visitorPhone = '',
          ownerName = '',
          ownerPhone = '',
          ownerRoomNo = '',
          rangeTimePicker,
          remark = '',
          visitorType = ''
        } = values;
        plateNos = plateNos.split(',');
        const startTime = moment(rangeTimePicker[0]).format('YYYY-MM-DD HH:mm');
        const endTime = moment(rangeTimePicker[1]).format('YYYY-MM-DD HH:mm');
        try {
          const { status, code, msg } = await addAppointmentRecord(
            JSON.stringify({
              parkId,
              plateNos,
              visitor,
              visitorPhone,
              ownerName,
              ownerPhone,
              ownerRoomNo,
              startTime,
              endTime,
              remark,
              visitorType
            })
          );
          if (status === '9999') {
            this.$message.success('添加成功');
            this.confirmLoading = false;
            this.visibleShow = false;
            this.$emit('addSuccess');
          }
        } catch (e) {
          this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
        } finally {
          this.confirmLoading = false;
        }
      }
    });
  }
  handleCancel() {
    this.visibleShow = false;
  }
  //车牌号转为大写
  changePlate({ target: { value } }: any) {
    if (value) {
      this.$nextTick(() => {
        this.form.setFieldsValue({
          plateNos: value.trim().toLocaleUpperCase()
        });
      });
    }
  }
}
